import { addDays, endOfDay, startOfDay } from 'date-fns';
import { useMemo } from 'react';
import { useExternalCalendarEventsQuery } from 'shared/hooks/queries/use-external-calendar-events-query';
import { useDebounceValue } from 'shared/hooks/use-debounce';
import { Timestamp } from 'shared/types/timestamp';

import { mapExternalEventToFullCalendarEvent } from '../utils/map-external-event-to-full-calendar-event';

export const useExternalCalendarFullCalendarEvents = (
  startDate: Timestamp,
  rangeInDays: number,
) => {
  const _startDate = useDebounceValue(startOfDay(startDate).toISOString());
  const _endDate = useDebounceValue(
    addDays(endOfDay(startDate), rangeInDays).toISOString(),
  );
  const { data } = useExternalCalendarEventsQuery(
    _startDate,
    _endDate,
    Intl.DateTimeFormat().resolvedOptions().timeZone,
  );

  return useMemo(
    () => data?.map(mapExternalEventToFullCalendarEvent) ?? [],
    [data],
  );
};
